import api from 'infra/config/api';

export default function postFeedback(data) {
    const url = '/new-feedback.php';
    return api
        .url(url)
        .post(data)
        .json();
}